<template>
<div>

  <div v-if="!editorMode" >
          <v-img :style="`border-radius: ${params.imageParams.radius} !important ;
                         ${getAlignment(params.align)} `"
                 :width="params.imageParams.width"
                 :height="params.imageParams.height"
                 :ratio="params.imageParams.ratio"
                 :position="params.imageParams.position"
                 :src="value" />

  </div>

  <div v-else
       @click="showParamsEdit"
       v-click-outside="closeParamsEdit"
       class="pa-3 editWindow " >

    <input style="display: none" id="fileInput" type="file"  @change="fileBrowsed">

      <v-sheet :set="hover = false"
               @dragover.prevent="dropzoneHover=true"
               @dragleave.prevent="dropzoneHover=false"
               @drop.prevent="drop"
               style="transition: all 0.3s ease; position: relative"
               :color="!value ? 'grey darken-1' : 'transparent' "
               :min-height="this.params.imageParams.height || this.params.imageParams.width  ? this.params.imageParams.height :  '200px'" >

        <v-sheet :color="dropzoneHover ? '#000000cc' : '#00000000' "
                 style="position:absolute; width: 100%; height: 100% !important;"
                 :style="`border-radius: ${params.imageParams.radius} !important ;`"
                 class=" d-flex align-center justify-center  ">

          <v-progress-circular dark v-if="LOADING" indeterminate />
          <div class="text-center " v-if="!value">
            <v-fade-transition mode="out-in">
              <div v-if="!loading">
                <v-icon x-large>mdi-tray-arrow-down</v-icon>
                <h4 class="font-weight-light"><b>Оберіть файл</b> або перетягніть сюди</h4>
              </div>

            </v-fade-transition>
          </div>

        </v-sheet>
            <v-img
                :style="`border-radius: ${params.imageParams.radius} !important ;
                         opacity : ${dropzoneHover ? '0' : ''}
                        ${getAlignment(params.align)} `                          "
                :width="params.imageParams.width"
                :height="params.imageParams.height"
                :ratio="params.imageParams.ratio"
                :position="params.imageParams.position"
                :src="value" />

      </v-sheet>

      <v-menu v-model="displayParamsEdit" absolute
            :position-y="paramsEditY"
            :position-x="paramsEditX"
            :close-on-click="false"
            :close-on-content-click="false" >

      <v-sheet dark  elevation="0" @click="displayParamsEdit = true">
        <div class="d-flex" >
          <ftParamsBar v-model="$store.state.templates.page.blocks[block].value.items[row][item].params"
                       @delete="deleteItem"
                       @hover="hoverAction"
                       :auto-input="['imageParams','margin','align','display','delete']" >

            <template slot="prepend">

              <v-btn @click="selectFile"
                     color="grey darken-3" x-large class="noCaps caption text-left" >

                <v-icon  size="30"  class="mr-1">mdi-image-multiple</v-icon>
                <span class="font-weight-light">{{ $t('Choose') }}    <br>
                  <span class="mt-2 font-weight-medium">
                      {{ $t('FromComputer') }}
                   </span>
                </span>

              </v-btn>

            </template>

          </ftParamsBar>
        </div>
      </v-sheet>

    </v-menu>
      <div ref="paramsEditCanvas" style="position: relative" > </div>
  </div>



</div>
</template>

<script>
import {mapState,mapActions} from "vuex";
import ftParamsBar from "@/components/templates/editor/UI/ftParamsBar";
// import imago from "@/components/UI/imago";

export default {
  name: "ft-text",
  props : ['value','item','block','row','params'],
  components : {
    // imago,
    ftParamsBar
  },
  data() {
      return {
        loading : false,
        paramsEditX : 0,
        paramsEditY : 0,
        displayParamsEdit : false,
        dropzoneHover : false,
        showUpload : false,
        imageLibraryId : this.$uuid.v4(),

        // OLD STUFF
        displayEdit : false,


      }
    },
  computed : {
    ...mapState('templates',  ['editorMode','businessAlias','imageLibraryFile','imageLibrarySenderId' ]),
  },
  watch : {
    imageLibraryFile(val){
     if ( this.imageLibraryId === this.imageLibrarySenderId) {
       this.$store.state.templates.page.blocks[this.block].value.items[this.row][this.item].value = val
     }
    }
  },
  methods : {

    ...mapActions('templates',  ['UPLOAD_IMAGE' ]),

    async drop(e) {
      this.uploadImage(e.dataTransfer.files[0])
    },

    async uploadImage(file) {
      let result = await this.UPLOAD_IMAGE(file)
      if  (!result) { return false }
      this.saveImage(result.url)
      this.dropzoneHover = false
    },

    selectFile() {
      document.getElementById('fileInput').click()
    },
    fileBrowsed(e) {
      this.dropzoneHover = true
      this.uploadImage(e.target.files[0])
    },

    saveImage(img) {
      this.$store.state.templates.page.blocks[this.block].value.items[this.row][this.item].value = img
      this.showUpload = false
    },
    deleteItem(){
      this.$store.state.templates.openEditorBlockElement   = true
      this.$store.state.templates.openEditorBlockDeleteElement   = true
      this.$store.state.templates.selectedBlock     = this.block
      this.$store.state.templates.selectedBlockItem = this.item
      this.$store.state.templates.selectedBlockColumn = this.row
    },

    showParamsEdit() {

      this.paramsEditX       = this.$refs.paramsEditCanvas.getBoundingClientRect().left
      this.paramsEditY       = this.$refs.paramsEditCanvas.getBoundingClientRect().top + 10
      this.displayParamsEdit = true

    },
    closeParamsEdit() {
      if ( !this.preventClose && this.displayParamsEdit  ) {
        this.displayParamsEdit = false
      }
    },
    hoverAction(val) {
      this.preventClose = val
    },

    // technical
    getAlignment(alignment) {
      switch ( alignment ) {
        case 'left'   : return ''
        case 'right'  : return 'margin-left : auto;'
        case 'center' : return 'margin-left : auto; margin-right : auto'
        default : return ''
      }
    }

  },
  beforeMount() {
     }
}
</script>

<style scoped>
.sideEditor {
  height: 100%;
  position: fixed;
  left: 0;
  top:0;
  width: 450px;
  z-index: 50000;
}
.editWindow {
  border : 1px #ffffffbb dashed;
}
.editWindow:hover {
  background-color: #ffffff55;
  cursor: pointer;
}
.dropzone {
  border: 2px whitesmoke dashed      !important ;
  transition: all 0.3s ease;
}
</style>